import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { ActivityFiltersComponent } from './activity-filters.component';

@NgModule({
    declarations: [ActivityFiltersComponent],
    imports: [CommonModule, MaterialModule, ReactiveFormsModule, FormsModule],
    exports: [ActivityFiltersComponent],
})
export class ActivityFiltersModule {}
